import * as yup from 'yup';
import { VALIDATORS } from 'core';

export const VALIDATION_SCHEMA = yup.object().shape({
  otherNames: VALIDATORS.firstName,
  familyName: VALIDATORS.lastName,
  gender: yup.string().required('Gender is required.'),
  address: VALIDATORS.address,
  mobile: yup.string().when('isChild', { is: (isChild: boolean) => !isChild, then: VALIDATORS.telephone }),
  telephone: yup.string().when('isChild', {
    is: (isChild: boolean) => !isChild,
    then: VALIDATORS.telephone.required("Alternative contact number field can't be empty."),
  }),
  guardianContactDetails: yup.object().when('isChild', {
    is: (isChild: boolean) => isChild,
    then: yup.object().shape({
      firstName: VALIDATORS.firstName,
      lastName: VALIDATORS.lastName,
      email: VALIDATORS.email,
      familyRelationshipId: yup.number().required('Relationship to the child is required.'),
      mobile: VALIDATORS.telephone,
      telephone: VALIDATORS.telephone.required('Your contact number is required.'),
    }),
  }),
});
